import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://maestros.ebookditales.com/cart/44752368664712:1';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const handleClick = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white" data-id="element-2">
      <button onClick={handleClick} className="w-full py-2 px-4 flex items-center justify-center gap-2 hover:bg-red-700 transition-colors" data-id="element-3">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-4" />
        <span className="text-sm font-medium" data-id="element-5">🔥 OFERTA TERMINA EN:</span>
        <span className="text-lg font-black tabular-nums bg-red-800 px-2 py-0.5 rounded" data-id="element-6">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
        <span className="text-sm font-medium hidden sm:inline" data-id="element-7">
          - ¡Aprovechá ahora!
        </span>
      </button>
    </div>;
}